import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminStorageApi from "../../api/admin/AdminStorage";
import { StorageInfoDto, StorageUpdateDto } from "../../../types/adminStorage";

const initialState = {
  storageList: [] as StorageInfoDto[],
  storageDetail: {} as StorageInfoDto,
  storageStoppedList: [] as StorageInfoDto[],
};

export const trunkGetStorageList = createAsyncThunk(
  "wapi/admins/storage/list",
  async () => {
    const resp = await adminStorageApi.getStorageList();
    return resp;
  }
);

export const trunkGetStorageStoppedList = createAsyncThunk(
  "wapi/admins/storage/R/list",
  async () => {
    const resp = await adminStorageApi.getStorageStoppedList();
    return resp;
  }
);

export const trunkGetStorageDetail = createAsyncThunk(
  "wapi/admins/storage/detail",
  async (serverKey: string) => {
    const resp = await adminStorageApi.getStorageDetail(serverKey);
    return resp;
  }
);

export const trunkCheckStorageStatus = createAsyncThunk(
  "wapi/admins/storage/check",
  async (serverKey: string) => {
    const resp = await adminStorageApi.checkStorageStatus(serverKey);
    return resp;
  }
);

export const trunkUpdateStorageStatus = createAsyncThunk(
  "wapi/admins/storage/update/detail",
  async (param: StorageUpdateDto) => {
    const resp = await adminStorageApi.updateStorageStatus(param);
    return resp;
  }
);

export const trunkDeleteStorage = createAsyncThunk(
  "wapi/admins/storage/delete",
  async (serverKey: string) => {
    const resp = await adminStorageApi.deleteStorage(serverKey);
    return resp;
  }
);

const adminStorageSlice = createSlice({
  name: "adminStorageStore",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(trunkGetStorageList.fulfilled, (state, { payload }) => {
      state.storageList = payload.storageList;
    });
    builder.addCase(
      trunkGetStorageStoppedList.fulfilled,
      (state, { payload }) => {
        state.storageStoppedList = payload.storageList;
      }
    );
    builder.addCase(trunkGetStorageDetail.fulfilled, (state, { payload }) => {
      state.storageDetail = payload;
    });
    builder.addCase(trunkUpdateStorageStatus.fulfilled, (state, req) => {
      // state.storageDetail = payload;
      state.storageList = state.storageList?.map((item) =>
        item.serverKey === req.meta.arg.serverKey
          ? { ...item, ...req.meta.arg }
          : item
      );
    });
    builder.addCase(trunkDeleteStorage.fulfilled, (state, { payload }) => {
      state.storageList = state.storageList.filter(
        (item) => item.serverKey !== payload.serverKey
      );
    });
  },
});

export default adminStorageSlice.reducer;
